export const USER_ID_SOURCE = 'USER_ID_SOURCE';
export const CHAT_ID_SOURCE = 'CHAT_ID_SOURCE';

export const previewByUserId = 'Profile:openPreviewByUserId';
export const closeUserPreview = 'Profile:closeUserPreview';
export const previewByChatId = 'Profile:openPreviewByChatId';
